import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import ReactTable from 'react-table';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { currency_symbol } from '../../../server/constants'
import {
    _addNotification, _addNotificationError,
    formatDate, allowNumericWithdecimal, getWeekStartEndDates, getMonthStartEndDates,
    getTodayStartEndDates, showFile,
    convertTwoDecimalPoint, getSessionStartEndDates, getModuleEnum, getAccessLevelByModule,getSchoolGrades
} from "../../../server/util";
import '../../../../src/assets/css/react-table.css';
import {depositTestdata} from './testDepositData'
import queryString from 'query-string';

import moment from 'moment';
import {get} from "../../../server/actionsNew";
import {getLoginDistrictInfo} from '../../../server/utilDistrict'
import { BeatLoader } from 'react-spinners';

var _ = require('lodash');
//let userInfo = getLoginDistrictInfo();
class depositSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            purchaseDataFilter: { tdate: 'D', sdate: new Date(), edate: new Date() },
            schoolID : 0,
            selectedSchoolData:{},
            userInfo : getLoginDistrictInfo()
          
        }

        this.getDepositSummery = this.getDepositSummery.bind(this);

    };
    // componentWillMount = () => {
    //     const parsed = queryString.parse(window.location.search);
    //     const schoolID = parseInt(parsed["schoolID"]) || 0
    //     this.setState({schoolID } )
        
    //     let selectedSchoolData = userInfo.schools.find((item)=> item.schoolId === schoolID)
    //     console.log(selectedSchoolData)
    //     this.setState({selectedSchoolData})
        
    // }
    componentDidMount = () => {
        this.getDepositSummery(false, this.props.selectSchool)
    }
    componentWillMount=()=>{
        this.props.changeShowHideSchoolFitler(true);
    }
    componentDidUpdate=(prevProps, prevState)=>{
        if(prevProps.selectSchool !== this.props.selectSchool ){
            console.log("componentDidUpdate------->",this.props.selectSchool)
           
            this.getDepositSummery(false,parseInt(this.props.selectSchool))
        }
    }
    getDepositSummery = (isPdf = false,schoolID=0) => {
        let _self = this;
        const schoolData = this.state.userInfo.schools.find((item)=> {if(item.schoolId === parseInt(this.props.selectSchool)){
          return item
        }})
        let schoolYear = 0
        if(schoolData){
            schoolYear = schoolData.activeSchoolYear || 0
        }
        let filterObj = this.state.purchaseDataFilter
        let date = {}
        if (filterObj.tdate === 'W') {
            date = getWeekStartEndDates(new Date())
        } else if (filterObj.tdate === 'M') {
            date = getMonthStartEndDates(new Date())
        } else if (filterObj.tdate === 'Y') {
            date = getSessionStartEndDates(sessionStorage.getItem('schoolYearValue'))
        } else if (filterObj.tdate === 'C') {
            date = { startDate: filterObj.sdate, endDate: filterObj.edate }
        } else {
            date = getTodayStartEndDates(new Date());
        }
        this.setState({ loading: true });
        get('/dashboard/balancePaymentTrend?mealSchoolId=' + schoolID +
            '&startDate=' + moment(date.startDate).utc().format("YYYY-MM-DDTHH:mm:ss")
            + '&endDate=' + moment(date.endDate).utc().format("YYYY-MM-DDTHH:mm:ss") +
            '&schoolYear=' + schoolYear +
            '&fileExport=' + isPdf + '&access_token=').then((response) => {
                if (!response.ok) {
                    if (response.status === 417) {
                        return response.json();
                    }
                    //throw Error(response.errorMessage);
                }
                console.log('response', response);
                return response;
            }).then(res => {
                if (res.statusCode === 417) {
                    // _addNotificationError(res.statusMessage,this)
                    throw Error(res.statusMessage);
                } else if (!res.statusCode === 200) {
                    throw Error(res.errorMessage);
                } else {
                    if (isPdf) {
                        return res.blob();
                    } else {
                        return res.json();
                    }
                }
            }).then(data => {
                if (isPdf) {
                    let filename = 'Deposits_Summery.pdf';
                    showFile(data, filename);
                    this.setState({ loading: false });
                } else {
                    let respData = [];
                    if (Object.keys(data).length > 0) {
                        Object.keys(data).map(item => {
                            respData.push({
                                transType: item,
                                noOfTrans: data[item].totalTransactions,
                                amount: data[item].totalAmount
                            });
                        })
                    }
                    this.setState({
                        depositSummery: respData, loading: false
                    })
                }
            }).catch(
                (error) => {
                    let msg = ''
                    if (typeof error === 'string') {
                        msg = error;
                    } else {
                        msg = error.message;
                    }
                    _addNotificationError(msg, _self)
                    //console.log('Get Excel File response', error)
                    this.setState({ loading: false })
                }
            );
    }

    render() {
        return (
            <div>
                <div className='sweet-loading'
                    style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <section>
                    <div className="container">
                        <div className="sectionTitle">
                            <h2>
                                <span>Deposit Summary</span>
                            </h2>
                        </div>
                        <div className="row ">
                      
                        <div style={{marginTop:60}}>
                                        <div className="panel panel-p1 panel-primary">
                                            <div className="panel-heading text-center">
                                                <h3 className="panel-title">Deposit Summary</h3>
                                            </div>
                                            <div className="panel-body">
                                                <div className="col-md-12"><div className="alert alert-info ">
                                                    <div onChange={(event) => {
                                                        let purchaseDataFilter = this.state.purchaseDataFilter;
                                                        purchaseDataFilter.tdate = event.target.value;
                                                        this.setState({ purchaseDataFilter: purchaseDataFilter })
                                                        if (event.target.value !== 'C')
                                                            this.getDepositSummery(false,this.props.selectSchool);
                                                    }}>
                                                        <label class="rbcontainer">Today
                                                    <input type="radio" name="pdrange" value="D" defaultChecked={this.state.purchaseDataFilter.tdate === 'D'} />
                                                            <span className="rbcheckmark"></span>
                                                        </label>
                                                        <label class="rbcontainer">This Week
                                                    <input type="radio" name="pdrange" value="W" defaultChecked={this.state.purchaseDataFilter.tdate === 'W'} />
                                                            <span className="rbcheckmark"></span>
                                                        </label>
                                                        <label class="rbcontainer">This Month
                                                    <input type="radio" name="pdrange" value="M" defaultChecked={this.state.purchaseDataFilter.tdate === 'M'} />
                                                            <span className="rbcheckmark"></span>
                                                        </label>
                                                        <label class="rbcontainer">This Year
                                                    <input type="radio" name="pdrange" value="Y" defaultChecked={this.state.purchaseDataFilter.tdate === 'Y'} />
                                                            <span className="rbcheckmark"></span>
                                                        </label>
                                                        <label class="rbcontainer">Custom Date Range
                                                    <input type="radio" name="pdrange" value="C" defaultChecked={this.state.purchaseDataFilter.tdate === 'C'} />
                                                            <span className="rbcheckmark"></span>
                                                        </label>
                                                        {
                                                            this.state.purchaseDataFilter.tdate === 'C' ?
                                                                <DateRangePicker startDate={this.state.purchaseDataFilter.sdate} endDate={this.state.purchaseDataFilter.edate} onApply={(event, picker) => {
                                                                    let purchaseDataFilter = this.state.purchaseDataFilter;
                                                                    purchaseDataFilter.sdate = picker.startDate._d;
                                                                    purchaseDataFilter.edate = picker.endDate._d;
                                                                    this.setState({ purchaseDataFilter: purchaseDataFilter })
                                                                    this.getDepositSummery(false,this.props.selectSchool);
                                                                    console.log('sdate --:', event, picker)
                                                                }}>
                                                                    <button className="btn btn-xs bg-color-1" style={{ margin: '0px' }}><i className="fa fa-calendar"></i></button>
                                                                </DateRangePicker> : null
                                                        }
                                                        <a title="Click to Download PDF"
                                                            onClick={() => { this.getDepositSummery(true,this.props.selectSchool) }//this.quickReports('Pdf','currentDay')
                                                        } target='_blank'
                                                            className="fa fa-file-pdf-o fa-2x QuickReports-PDF pull-right"><i /></a>
                                                    </div>
                                                </div></div>
                                                <div className="col-md-12">
                                                    <ReactTable
                                                        filterable
                                                        columns={[
                                                            {
                                                                Header: "S.No",
                                                                filterable: false,
                                                                width: 100,
                                                                style: { textAlign: 'center' },
                                                                Cell: row => {
                                                                    return <span>{row.index + 1}</span>
                                                                }
                                                            },
                                                            {
                                                                Header: "Transaction Type",
                                                                accessor: "transType",
                                                                style: { textAlign: 'center' },
                                                                filterMethod: (filter, row) => {
                                                                    const _row = row._original
                                                                    return (_row[filter.id]).toLowerCase().startsWith(filter.value.toLowerCase())
                                                                },
                                                                Filter: ({ filter, onChange }) => {
                                                                    return (
                                                                        <select className="form-control"
                                                                            onChange={event => onChange(event.target.value)}
                                                                            value={filter ? filter.value : 'all'}
                                                                        >
                                                                            <option value={''}>{''}</option>
                                                                            {_.map(
                                                                                _.uniq(
                                                                                    _.map(this.state.depositSummery, function (obj) {
                                                                                        return obj.transType;
                                                                                    })
                                                                                )).map(item =>
                                                                                    <option value={item}>{item}</option>
                                                                                )
                                                                            }
                                                                        </select>
                                                                    )
                                                                }
                                                            },
                                                            {
                                                                Header: "Total Transactions",
                                                                filterable: false,
                                                                accessor: "noOfTrans",
                                                                style: { textAlign: 'center' },
                                                                Cell: row => (<span style={{ textAlign: 'center' }}>{row.original.noOfTrans}</span>)
                                                            },
                                                            {
                                                                Header: "Transaction Amount",
                                                                accessor: "amount",
                                                                style: { textAlign: 'center' },
                                                                filterable: false,
                                                                Cell: row => (<span style={{ textAlign: 'center' }}>{ '$ ' + convertTwoDecimalPoint(row.original.amount)}</span>)
                                                            }
                                                        ]} data={this.state.depositSummery} defaultPageSize={10} className="-striped -highlight" />

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                        </div>

                    </div>
                </section>
            </div>

        );
    }
}

export default depositSummary;




// WEBPACK FOOTER //
// ./src/components/District/Deposits/depositSummary.jsx